const en = {
  "nav_home": "Home",
  "nav_about": "About",
  "nav_services": "Services",
  "nav_blog": "Blog",
  "nav_login": "Login",
  "nav_register": "Register",
  "nav_dashboard": "Dashboard",
  "nav_logout": "Logout",
  "hero_title": "Global invoice financing platform",
  "hero_subtitle": "TradeFlow is a digital origination, underwriting and servicing platform for cross-border B2B invoice finance. Funding is provided by banks, factors and private credit partners.",
  "hero_cta": "View demo transaction",
  "hero_secondary": "How it works",
  "scoring_title": "Preliminary Assessment",
  "scoring_subtitle": "Estimate a financing limit for an illustrative receivable in 2 minutes",
  "scoring_company": "Company name",
  "scoring_revenue": "Annual revenue ($)",
  "scoring_years": "Years in Business",
  "scoring_industry": "Industry",
  "scoring_country": "Country",
  "scoring_invoices": "Outstanding invoices ($)",
  "scoring_financial": "Have Financial Statements",
  "scoring_bank": "Have Bank Statements",
  "scoring_submit": "Calculate Limit",
  "scoring_result_title": "Assessment Result",
  "scoring_score": "Score",
  "scoring_risk": "Risk Level",
  "scoring_limit": "Preliminary Limit",
  "scoring_recommendations": "Recommendations",
  "risk_low": "Low",
  "risk_moderate": "Moderate",
  "risk_elevated": "Elevated",
  "risk_high": "High",
  "industry_manufacturing": "Manufacturing",
  "industry_trade": "Trade",
  "industry_services": "Services",
  "industry_logistics": "Logistics",
  "industry_agriculture": "Agriculture",
  "industry_it": "IT",
  "industry_construction": "Construction",
  "industry_other": "Other",
  "auth_login_title": "Sign In",
  "auth_register_title": "Create Account",
  "auth_email": "Email",
  "auth_password": "Password",
  "auth_confirm_password": "Confirm Password",
  "auth_full_name": "Full Name",
  "auth_company": "Company Name",
  "auth_phone": "Phone",
  "auth_role": "Account Type",
  "auth_submit_login": "Sign In",
  "auth_submit_register": "Create Account",
  "auth_no_account": "Don't have an account?",
  "auth_have_account": "Already have an account?",
  "auth_social_login": "Sign in with",
  "auth_coming_soon": "Coming Soon",
  "role_client_buyer": "Buyer / Importer",
  "role_client_seller": "Seller / Exporter",
  "role_agent": "Originator / Agent",
  "role_partner_investor": "Investor",
  "role_partner_institution": "Bank / Financial Partner",
  "dash_overview": "Overview",
  "dash_documents": "Documents",
  "dash_invoices": "Invoices",
  "dash_deals": "Deals",
  "dash_offers": "Offers",
  "dash_blog": "Blog",
  "dash_settings": "Settings",
  "dash_analytics": "Analytics",
  "dash_users": "Users",
  "dash_scoring": "Scoring",
  "stats_total_financed": "Total Financed",
  "stats_active_deals": "Active Deals",
  "stats_exposure": "Available Limit",
  "stats_pending": "Pending Review",
  "action_upload": "Upload",
  "action_create": "Create",
  "action_edit": "Edit",
  "action_delete": "Delete",
  "action_view": "View",
  "action_approve": "Approve",
  "action_reject": "Reject",
  "action_fund": "Fund",
  "action_publish": "Publish",
  "action_save": "Save",
  "action_cancel": "Cancel",
  "section_stories": "Demo Evidence",
  "section_offers": "Partner Opportunities",
  "section_logistics": "Logistics Services",
  "section_how_it_works": "How It Works",
  "section_partners": "Our Partners",
  "footer_about": "About",
  "footer_contact": "Contact",
  "footer_terms": "Terms of Service",
  "footer_privacy": "Privacy Policy",
  "footer_copyright": "© 2024 TradeFlow. All rights reserved.",
  "msg_success": "Success",
  "msg_error": "Error",
  "msg_loading": "Loading...",
  "msg_no_data": "No data",
  "nav": {
    "demo": "Demo"
  },
  "hero": {
    "badge": "Global invoice financing platform",
    "statSpeedValue": "60d",
    "statSpeedLabel": "Typical receivable tenor",
    "statAdvanceValue": "80%",
    "statAdvanceLabel": "Illustrative advance rate",
    "statPartnersValue": "4",
    "statPartnersLabel": "Workflow participants",
    "approvedTitle": "Demo receivable approved",
    "approvedMeta": "$160,000 funding request"
  },
  "demo": {
    "badge": "Illustrative demo transaction",
    "title": "One cross-border invoice, shown from submission to repayment",
    "subtitle": "This is not a live transaction. It shows the transaction architecture TradeFlow is built to originate, underwrite and service for banks, factors and private credit partners.",
    "caseTitle": "Demo case: industrial equipment invoice",
    "sellerLabel": "Chinese seller",
    "buyerLabel": "Kazakhstan buyer",
    "corridorLabel": "Corridor",
    "statusLabel": "Status",
    "metrics": {
      "invoice": "Invoice",
      "term": "Payment term",
      "advance": "Advance rate",
      "financing": "Financing required",
      "pricing": "Indicative pricing",
      "fee": "TradeFlow fee"
    },
    "roles": {
      "seller": {
        "title": "Seller view",
        "items": [
          "Invoice submitted",
          "Buyer confirmed",
          "$160,000 funding ready"
        ]
      },
      "buyer": {
        "title": "Buyer view",
        "items": [
          "Invoice reviewed",
          "Payment obligation confirmed",
          "Due in 60 days"
        ]
      },
      "underwriter": {
        "title": "Underwriter view",
        "items": [
          "Risk grade B+",
          "Documents verified",
          "Recommended advance 80%"
        ]
      },
      "funder": {
        "title": "Funder view",
        "items": [
          "$160,000 deployment",
          "60-day tenor",
          "Repayment source: buyer payment"
        ]
      }
    },
    "steps": [
      {
        "title": "Seller submits invoice",
        "detail": "Chinese supplier uploads invoice, contract, shipment evidence and buyer details."
      },
      {
        "title": "Buyer confirms obligation",
        "detail": "Kazakh buyer confirms the invoice, payment date and non-dispute status."
      },
      {
        "title": "TradeFlow underwrites",
        "detail": "Seller, buyer, invoice evidence, tenor, corridor and fraud controls are scored."
      },
      {
        "title": "Funder finances receivable",
        "detail": "Bank, factor or fund deploys $160,000 against the approved receivable."
      },
      {
        "title": "Buyer repays at maturity",
        "detail": "Buyer pays $200,000 after 60 days; funder receives capital and return."
      }
    ],
    "lenderTitle": "TradeFlow is not presented as the lender in this demo.",
    "lenderText": "The platform owns origination, underwriting workflow, document evidence, confirmations and servicing. A bank, factor or credit fund finances the receivable.",
    "cta": "View workflow"
  },
  "scoring": {
    "empty": "Complete the form to receive a preliminary assessment",
    "fullAssessment": "Request full assessment",
    "industryPlaceholder": "Select industry"
  },
  "how": {
    "title": "A simple path from invoice to funding",
    "steps": [
      {
        "title": "Upload documents",
        "description": "Invoice, contract, shipment evidence and company documents are collected in one workflow."
      },
      {
        "title": "Receive assessment",
        "description": "TradeFlow scores the seller, buyer, invoice evidence, tenor and corridor."
      },
      {
        "title": "Match with funding partner",
        "description": "Approved receivables are prepared for banks, factors or credit funds."
      },
      {
        "title": "Receive proceeds",
        "description": "The seller receives the advance while TradeFlow services the transaction through repayment."
      }
    ]
  },
  "stories": {
    "title": "What the demo proves",
    "cards": [
      {
        "quote": "A bank can see the borrower, buyer, evidence package and economics in one place.",
        "author": "Funding partner",
        "company": "Kazakhstan bank / fund",
        "role": "Balance sheet provider"
      },
      {
        "quote": "A supplier can request early payment without becoming the lender or negotiating manually with each institution.",
        "author": "Chinese exporter",
        "company": "Demo Machinery Co.",
        "role": "Seller"
      },
      {
        "quote": "A buyer can confirm the commercial obligation and payment date without changing the trade relationship.",
        "author": "Kazakh importer",
        "company": "Demo Distribution LLP",
        "role": "Buyer"
      }
    ]
  },
  "offers": {
    "title": "Partner roles TradeFlow is seeking",
    "cards": [
      {
        "title": "Funding partners",
        "description": "Banks, factors and private credit funds that want qualified cross-border invoices.",
        "company": "Capital providers",
        "offer_type": "financing"
      },
      {
        "title": "Origination partners",
        "description": "Logistics, exporter and importer networks that can surface real transactions.",
        "company": "Distribution partners",
        "offer_type": "logistics"
      },
      {
        "title": "Institutional pilots",
        "description": "Kazakhstan trade-finance teams willing to test underwriting requirements on demo cases.",
        "company": "Pilot partners",
        "offer_type": "service"
      }
    ],
    "detail": "Details"
  },
  "footer": {
    "tagline": "Digital origination, underwriting and servicing for cross-border receivables finance.",
    "companyHeading": "Company",
    "servicesHeading": "Services",
    "legalHeading": "Legal",
    "careers": "Partnerships",
    "factoring": "Receivables finance",
    "tradeFinance": "Trade finance workflow",
    "bnpl": "Institutional funding rails"
  },
  "home": {
    "nav": {
      "demo": "Demo Transaction"
    },
    "hero": {
      "badge": "Global invoice financing platform",
      "statSpeedValue": "60d",
      "statSpeedLabel": "Typical receivable tenor",
      "statAdvanceValue": "80%",
      "statAdvanceLabel": "Illustrative advance rate",
      "statPartnersValue": "4",
      "statPartnersLabel": "Workflow participants",
      "approvedTitle": "Demo receivable approved",
      "approvedMeta": "$160,000 funding request"
    },
    "demo": {
      "badge": "Illustrative demo transaction",
      "title": "One cross-border invoice, shown from submission to repayment",
      "subtitle": "This is not a live transaction. It shows the transaction architecture TradeFlow is built to originate, underwrite and service for banks, factors and private credit partners.",
      "caseTitle": "Demo case: industrial equipment invoice",
      "sellerLabel": "Chinese seller",
      "buyerLabel": "Kazakhstan buyer",
      "corridorLabel": "Corridor",
      "statusLabel": "Status",
      "statusValue": "Approved for funding",
      "metrics": {
        "invoice": "Invoice",
        "term": "Payment term",
        "advance": "Advance rate",
        "financing": "Financing required",
        "pricing": "Indicative pricing",
        "fee": "TradeFlow fee"
      },
      "roles": {
        "seller": {
          "title": "Seller view",
          "items": [
            "Invoice submitted",
            "Buyer confirmed",
            "$160,000 funding ready"
          ]
        },
        "buyer": {
          "title": "Buyer view",
          "items": [
            "Invoice reviewed",
            "Payment obligation confirmed",
            "Due in 60 days"
          ]
        },
        "underwriter": {
          "title": "Underwriter view",
          "items": [
            "Risk grade B+",
            "Documents verified",
            "Recommended advance 80%"
          ]
        },
        "funder": {
          "title": "Funder view",
          "items": [
            "$160,000 deployment",
            "60-day tenor",
            "Repayment source: buyer payment"
          ]
        }
      },
      "steps": [
        {
          "title": "Seller submits invoice",
          "detail": "Chinese supplier uploads invoice, contract, shipment evidence and buyer details."
        },
        {
          "title": "Buyer confirms obligation",
          "detail": "Kazakh buyer confirms the invoice, payment date and non-dispute status."
        },
        {
          "title": "TradeFlow underwrites",
          "detail": "Seller, buyer, invoice evidence, tenor, corridor and fraud controls are scored."
        },
        {
          "title": "Funder finances receivable",
          "detail": "Bank, factor or fund deploys $160,000 against the approved receivable."
        },
        {
          "title": "Buyer repays at maturity",
          "detail": "Buyer pays $200,000 after 60 days; funder receives capital and return."
        }
      ],
      "lenderTitle": "TradeFlow is not presented as the lender in this demo.",
      "lenderText": "The platform owns origination, underwriting workflow, document evidence, confirmations and servicing. A bank, factor or credit fund finances the receivable.",
      "cta": "View workflow"
    },
    "roles": {
      "badge": "Platform roles",
      "title": "Choose your role in the transaction",
      "subtitle": "TradeFlow is designed around the real participants in a cross-border receivables finance transaction, not around one generic user account.",
      "cta": "Register with the right role",
      "items": [
        {
          "title": "Seller / Exporter",
          "description": "Uploads invoices, contracts and shipment evidence; requests early payment against confirmed receivables."
        },
        {
          "title": "Buyer / Importer",
          "description": "Confirms invoice validity, payment date and non-dispute status so funders can rely on the obligation."
        },
        {
          "title": "Originator / Agent",
          "description": "Introduces sellers, buyers or trade transactions and helps prepare a clean funding package."
        },
        {
          "title": "Investor",
          "description": "Reviews approved receivables, expected economics, tenor and risk grade before allocating capital."
        },
        {
          "title": "Bank / Financial Partner",
          "description": "Provides balance-sheet funding or factoring capacity while TradeFlow handles origination, workflow and servicing."
        }
      ]
    },
    "scoring": {
      "empty": "Complete the form to receive a preliminary assessment",
      "fullAssessment": "Request full assessment",
      "industryPlaceholder": "Select industry",
      "companyPlaceholder": "Demo Trading LLP",
      "revenuePlaceholder": "500000",
      "invoicesPlaceholder": "200000"
    },
    "how": {
      "title": "A simple path from invoice to funding",
      "steps": [
        {
          "title": "Upload documents",
          "description": "Invoice, contract, shipment evidence and company documents are collected in one workflow."
        },
        {
          "title": "Receive assessment",
          "description": "TradeFlow scores the seller, buyer, invoice evidence, tenor and corridor."
        },
        {
          "title": "Match with funding partner",
          "description": "Approved receivables are prepared for banks, factors or credit funds."
        },
        {
          "title": "Receive proceeds",
          "description": "The seller receives the advance while TradeFlow services the transaction through repayment."
        }
      ]
    },
    "stories": {
      "title": "What the demo proves",
      "cards": [
        {
          "quote": "A bank can see the borrower, buyer, evidence package and economics in one place.",
          "author": "Funding partner",
          "company": "Kazakhstan bank / fund",
          "role": "Balance sheet provider"
        },
        {
          "quote": "A supplier can request early payment without becoming the lender or negotiating manually with each institution.",
          "author": "Chinese exporter",
          "company": "Demo Machinery Co.",
          "role": "Seller"
        },
        {
          "quote": "A buyer can confirm the commercial obligation and payment date without changing the trade relationship.",
          "author": "Kazakh importer",
          "company": "Demo Distribution LLP",
          "role": "Buyer"
        }
      ]
    },
    "offers": {
      "title": "Partner roles TradeFlow is seeking",
      "detail": "Details",
      "cards": [
        {
          "title": "Funding partners",
          "description": "Banks, factors and private credit funds that want qualified cross-border invoices.",
          "company": "Capital providers",
          "offer_type": "financing"
        },
        {
          "title": "Origination partners",
          "description": "Logistics, exporter and importer networks that can surface real transactions.",
          "company": "Distribution partners",
          "offer_type": "logistics"
        },
        {
          "title": "Institutional pilots",
          "description": "Kazakhstan trade-finance teams willing to test underwriting requirements on demo cases.",
          "company": "Pilot partners",
          "offer_type": "service"
        }
      ]
    },
    "footer": {
      "tagline": "Digital origination, underwriting and servicing for cross-border receivables finance.",
      "companyHeading": "Company",
      "servicesHeading": "Services",
      "legalHeading": "Legal",
      "careers": "Partnerships",
      "factoring": "Receivables finance",
      "tradeFinance": "Trade finance workflow",
      "bnpl": "Institutional funding rails"
    }
  },
    "authPage": {
      "sideTitle": "Working capital for cross-border trade growth",
      "sideSubtitle": "Access invoice-finance workflow for cross-border B2B transactions.",
      "financed": "Demo volume",
      "clients": "Participants",
      "speedValue": "60d",
      "speed": "Typical tenor",
      "loginDescription": "Sign in to your account",
      "registerDescription": "Create an account to start the workflow",
      "welcome": "Welcome back",
      "loginError": "Login failed",
      "passwordsMismatch": "Passwords do not match",
      "passwordTooShort": "Password must contain at least 6 characters",
      "registerSuccess": "Registration successful",
      "registerError": "Registration failed",
      "fullNamePlaceholder": "Ivan Petrov",
      "companyPlaceholder": "Demo Trading LLP",
      "showPasswords": "Show passwords",
      "hidePasswords": "Hide passwords"
    },
    "dashboard": {
      "clients": "Clients",
      "portfolio": "Portfolio",
      "search": "Search...",
      "welcome": "Welcome",
      "accountSummary": "Here is what is happening in your account",
      "notCompleted": "Not completed",
      "users": "Users",
      "recentDeals": "Recent deals",
      "noDeals": "No deals",
      "profile": "Profile",
      "name": "Name",
      "company": "Company",
      "phone": "Phone",
      "interfaceLanguage": "Interface language",
      "socialAccounts": "Social accounts",
      "linkedAccounts": "Linked accounts for sign-in",
      "languageChanged": "Language changed",
      "monthlyRevenue": "Monthly revenue",
      "totalDeals": "Total deals",
      "conversion": "Conversion",
      "keyMetrics": "Key metrics",
      "invoicesMetric": "Invoices",
      "activeUsers": "Active",
      "blockedUsers": "Blocked",
      "blockUser": "Block",
      "unblockUser": "Unblock",
      "offersSoon": "Offer management will be available soon",
      "blogSoon": "Blog management will be available soon",
      "table": {
        "amount": "Amount",
        "advance": "Advance",
        "status": "Status",
        "date": "Date",
        "title": "Title",
        "type": "Type",
        "size": "Size",
        "number": "Number",
        "debtor": "Debtor",
        "dueDate": "Due date",
        "fee": "Fee",
        "role": "Role"
      },
      "documents": {
        "uploadTitle": "Upload document",
        "type": "Document type",
        "title": "Title",
        "description": "Description",
        "file": "File",
        "selectFile": "Select a file",
        "loadError": "Failed to load documents",
        "uploadSuccess": "Document uploaded",
        "uploadError": "Upload failed",
        "deleteSuccess": "Document deleted",
        "deleteError": "Delete failed",
        "invoice": "Invoice",
        "financial_statement": "Financial statement",
        "bank_statement": "Bank statement",
        "incorporation": "Incorporation documents",
        "contract": "Contract",
        "other": "Other"
      },
      "invoices": {
        "createTitle": "New invoice",
        "number": "Invoice number",
        "debtor": "Debtor",
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "factoring": "Factoring",
        "loadError": "Failed to load invoices",
        "createSuccess": "Invoice created",
        "createError": "Failed to create invoice",
        "factoringSuccess": "Factoring request sent"
      },
      "deals": {
        "loadError": "Failed to load deals",
        "approveSuccess": "Deal approved",
        "fundSuccess": "Deal funded"
      },
      "usersTab": {
        "loadError": "Failed to load users",
        "statusChanged": "Status changed"
      },
      "status": {
        "pending_approval": "Pending review",
        "pending_review": "Under review",
        "pending": "Pending",
        "approved": "Approved",
        "funded": "Funded",
        "rejected": "Rejected",
        "active": "Active"
      },
      "genericError": "Error"
    }
};

export default en;
